export default "__VITE_ASSET__ca84dcbd__"